import { createTableConfig } from '../createTableConfig';

export const memo = createTableConfig({ columns: {} });
